// ============================================================================
// Unified configuration for ALL cached pharmacy customer sections.
// Combines Packets, PillPack, and Non-Mobile Enrollment into a single
// ordered list of sections for the sidebar navigation.
// ============================================================================

import { CustomerTypeEntry, CustomerTypeSection, CUSTOMER_TYPE_SECTIONS } from "./user-type-config-mapping";
import { pillpackCustomerTypePaths, pillpackCustomerTypeMapping } from "./pillpack-config";
import { nonMobileEnrollmentCustomerTypePaths, nonMobileEnrollmentCustomerTypeMapping } from "./non-mobile-enrollment-config";

export type { CustomerTypeEntry, CustomerTypeSection };

// ---- PillPack ----
const PILLPACK: CustomerTypeSection = {
    title: "PillPack",
    entries: Object.entries(pillpackCustomerTypePaths).map(([key, path]) => ({
        key,
        path,
        description: (pillpackCustomerTypeMapping as Record<string, string>)[key] || key,
    })),
};

// ---- Non-Mobile Enrollment ----
const NON_MOBILE_ENROLLMENT: CustomerTypeSection = {
    title: "Non-Mobile Enrollment",
    entries: Object.entries(nonMobileEnrollmentCustomerTypePaths).map(([key, path]) => ({
        key,
        path,
        description: (nonMobileEnrollmentCustomerTypeMapping as Record<string, string>)[key] || key,
    })),
};

// ============================================================================
// All sections in sidebar order
// ============================================================================
export const ALL_CUSTOMER_TYPE_SECTIONS: CustomerTypeSection[] = [
    ...CUSTOMER_TYPE_SECTIONS,
    PILLPACK,
    NON_MOBILE_ENROLLMENT,
];
